// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/css/reset.css'
import 'lib-flexible/flexible';//在入口文件引入然后运行
import App from './App'
import $ from 'jquery'
import axios from 'axios';
import router from './router'
import store from './store'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.prototype.$ajax = axios;
const defVue = new Vue({
	el: '#app',
	render: h => h(App),
	router,
	store,
	beforeCreate: function() {
		// this.$router.addRoutes([minrouter]);
		// this.$router.options.routes.push(minrouter);
	},
	template: '<App/>',
	components: { App }
})
export default defVue;


// WEBPACK FOOTER //
// ./src/main.js